<template>
  <div id="album-detail" :class="['play', issafariBrowser&&!album.isPay?'in-safari':'']">
    <template v-if="albumType == 0">
      <MVideo
        v-show="!showPayPrompt"
        :path="path"
        ref="mvideo"
        class="mvideo"
        :poster="album.cover_url_large"
        :resour-info="resour"
        @ended="playEnd"
        @overtured="showPayPrompt=true"
        @back="back"
        @onplay="onPlay"
      />
    </template>
    <template v-else>
      <div class="maudio" :style="{backgroundImage: 'url('+album.cover_url_large+')'}" @click.stop="play(index, true)">
        <div><img src="@/assets/icon_audio_play.png"></div>
      </div>
    </template>

    <div v-show="showPayPrompt" class="pay-prompt">
      <!-- <div class="to-back"><img src="@/assets/icon_back_white.png" @click="back" ></div> -->
      <div class="prompt">{{ videoInfo.membercontent }}</div>
      <button @click="showPayHandle">准了</button>
    </div>
    <div class="content" id="pay-content">
      <div class="content-flow">
        <div class="info">
          <div class="title">{{ album.album_title }}</div>
          <div class="desc"><span v-if="album.is_paid != 0" class="vip-tag">付费购买</span><span>全{{videos.length}}集</span></div>
        </div>
        <ADesc :desc="album.album_intro" />
        <div class="paybutton"><MPay ref="mpay" :album="album" v-show="(!album.isPay)&&(album.is_paid != 0)"/></div>
        <Menu :album-type="albumType" :videos="videos" :videoInfo="videoInfo" :is-pay="album.isPay" :paytag="'付费'" @click="menuItemClick" @showall="showMenuAll" />
        <ARecommend :albumid="albumId" />
      </div>
    </div>
    <div v-if="isShowAllMenu" :class="['allmenu', isShowAllMenu?'open':'close']"><AllMenu :album-type="albumType" :videos="videos" :videoInfo="videoInfo" :is-pay="album.isPay" :paytag="'付费'" @click="menuItemClick" @close="isShowAllMenu = false" /></div>
  </div>
</template>

<script>
import MVideo from '../player/video'
import MPay from '../models/pay/index'
import ADesc from '../models/desc'
import Menu from '../models/menu/slide'
import AllMenu from '../models/menu/list'
import ARecommend from '../models/recommend'

import { albumInfo } from '@/api/detail'
import { umtrack } from '@/utils/uweb'
import { isAndroidOrIos } from '@/utils/index'
import { setTitle } from '@/api/app'

import { getHistoryForId } from '../history/models/storage'
export default {
  name: 'recommend',
  components: {
    MVideo,
    MPay,
    Menu, AllMenu, ADesc, ARecommend
  },
  filters: {
    duration(time){
      const second = time%60
      const m = (time-second)/60
      const minut = m%60
      const hour = (m-minut)/60
      return (hour != 0? hour+':':'')+minut+':'+second
    }
  },
  computed: {
    resour: function() {
      return {
        albumId: this.albumId,
        albumTitle: this.album.album_title,
        albumImage: this.album.cover_url_large,
        playid: this.index,
        playTitle: this.videoInfo.videoname,
        videoId: this.videoInfo.id
      }
    }
  },
  created () {
    var query = this.$route.query
    if(query.hasOwnProperty('id')){
      this.albumId = query.id
    }
    umtrack('albumView', {id: this.albumId}, this)
    const history = getHistoryForId(this.albumId)
    if(history){
      this.index = history.playid
    }
  },
  data () {
    return {
      albumId: 0,
      albumType: 0, // 专辑类型 0 视频 1 音频
      path:'',
      index: 0,
      album: {},
      videos: [],
      videoInfo: {},
      showPayPrompt: false,
      issafariBrowser: false,
      // adType: 0, // 广告的播放状态 0 未播放广告 1 正在播放广告 2 广告播放完成
      current_os: isAndroidOrIos(),
      isShowAllMenu: false
    }
  },
  mounted() {
    this.getAlbumInfo().then(()=>{
      setTitle(this.album.album_title)
      this.play(this.index, false)
    })
    window.addEventListener('pageshow', (e)=>{
      if(e.persisted){
        window.location.reload()
      }
    })
    // 判断是否在safair中打开
    this.issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    var isShowPayHandle = sessionStorage.getItem("showPayHandle")
    if(Number(isShowPayHandle) === 1){
      sessionStorage.setItem("showPayHandle", 0)
      this.showPayHandle()
    }
    // fwatch 中广告关闭回调
    window.onAdClosed = () => {
      this.onAdClosed()
    }
  },
  methods: {
    getAlbumInfo(){
      return new Promise((resolve, reject)=>{
        albumInfo({id: this.albumId}).then((response)=>{
          var data = response.data.data
          this.albumType = data.album_type
          // this.adType = data.noAd?2:0
          this.videos = data.list
          delete data.list
          this.album = data
          resolve()
        }).catch((e)=>{
          this.$router.replace({path: '/album_off'})
          reject()
        })
      })
    },
    play(index, istart) {
      // 在播放广告的时候禁止切换
      // if(this.adType == 1){
      //   return
      // }
      this.index = index
      this.showPayPrompt = false
      this.videoInfo = this.videos[index]
      this.setDTitle(this.albumType == 0 ? this.videoInfo.videoname : this.videoInfo.track_title)
      // 音频播放
      if(this.albumType != 0){
        if(!istart){
          return
        }
        if(this.videoInfo.ispay || this.videoInfo.tryseetime > 0){
          this.$store.commit('SET_AUDIOLIST', this.videos)
          this.$router.push({path: '/audio', query: {index: index}})
        } else {
          this.showPayHandle()
        }
        return
      }
      // 视频播放
      if(this.videoInfo.ispay){
        // 对于支付后的视屏不在播放广告
        // this.adType = 2
        umtrack('play', {id: this.videoInfo.id, title: this.videoInfo.videoname}, this)
        this.path = JSON.parse(this.videoInfo.clarityurl)[0].url
        if(istart){
          this.$refs.mvideo.play()
        }
        return
      }
      // 试看
      if(this.videoInfo.tryseetime > 0){
        umtrack('tryPlay', {id: this.videoInfo.id, title: this.videoInfo.videoname}, this)
        this.path = JSON.parse(this.videoInfo.clarityurl)[0].url
        if(istart){
          this.$refs.mvideo.overture(this.videoInfo.tryseetime/1000, istart)
        }
        return
      }
      // 引导支付
      umtrack('noPay', {id: this.album.id, title: this.album.album_title}, this)
      this.$refs.mvideo.stop()
      this.showPayPrompt = true
    },
    playEnd() {
      this.index = (this.index+1)%this.videos.length;
      this.play(this.index, true)
    },
    back() {
      this.$router.go(-1)
    },
    menuItemClick(key){
      this.isShowAllMenu = false
      this.play(key, true)
    },
    setDTitle(title) {
      // 设置title
      document.title = title
    },
    showPayHandle(){
      this.$refs.mpay.showPayHandle()
    },
    onPlay() {
      // 正在播放视频或者没有播放视频的情况下需要暂停视频的播放
      // if(this.playAd() || this.adType==1){
      //   this.$refs.mvideo.stop()
      // }
    },
    // playAd(){
    //   // 判断广告的状态
    //   if(this.adType == 0){
    //     // 暂停视频
    //     const result = playAdVideo()
    //     if(result){
    //       this.adType = 1
    //     }
    //     return result
    //   }
    //   return false
    // },
    // onAdClosed() {
    //   this.adType = 2
    //   this.$refs.mvideo.overture(this.videoInfo.tryseetime/1000, true)
    // },
    showMenuAll() {
      this.isShowAllMenu = true
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$playHeight: 56.25vw;
.play{
  color: #333;
  // display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  .mvideo{
    width: 100%;
    height: $playHeight;
  }
  .maudio{
    width: 100%;
    height: $playHeight;
    display: flex;
    align-items: center;
    background-size: 100% 56.25vw;
    &>div{
      flex: 1;
    }
  }
  .pay-prompt{
    width: 100%;
    height: $playHeight;
    // z-index: 1;
    // position:absolute;
    // top: 0;
    background-color: #000;
    color: #eee;
    font-size: 20px;
    text-align: center;
    .prompt{
      padding-top: 12vh;
    }
    button{
      border:none;
      background-color: rgb(245, 121, 19);
      color: #eee;
      padding: 2px 10px;
      border-radius: 4px;
      margin-top: 10px;
    }
  }
  .content{
    // flex: 1;
    height: calc(100vh - #{$playHeight});
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar{
      display: none;
    }
    .content-flow{
      display: flex;
      flex-direction: column;
      min-height: calc(100% + 1px);
      background-color: #fff;
      .paybutton{
        padding: 16px 16px 6px 16px;
      }
    }
  }
  .info{
    background-color: #fff;
    text-align: left;
    padding: 16px 16px 0 16px;
    .title{
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .desc{
      color: #666;
      font-size: 14px;
      line-height: 20px;
      .vip-tag{
        // background: linear-gradient(90deg, #F7DDB8 0%, #F3BB6F 100%);
        background-color: #FF6767;
        border-radius: 4px;
        color: #FFF;
        font-size: 12px;
        padding: 2px 6px;
        margin-right: 10px;
      }
    }
  }
  .coupon-guide{
    position: relative;
    background-color: #fff;
    padding: 16px 16px 0 16px;
    &>div{
      color: #754F19;
      font-size: 18px;
      padding: 12px 0;
      background: linear-gradient(90deg, #F9E0C3 0%, #F3BB6D 100%);
      border-radius: 8px;
    }
  }
  .allmenu{
    position: fixed;
    top: $playHeight;
    z-index: 100;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    &.open{
      animation: showAllMenu 0.24s ease-in;
    }
    &.close{
      animation: closeAllMenu 0.2s ease-out;
    }
  }
  ::v-deep .play-menu{
    .table-header .menu-all>span{
      display: none;
    }
    .table-content .menu .item{
      border-color: #ccc;
      .vip-tag{
        color: #fff;
        background: #FF6767;
      }
      &.play{
        border-color: #FF6767;
      }
    }
  }
  ::v-deep .play-all-menu{
    .table-header .menu-all>span{
      display: none;
    }
    .table-content .menu .item{
      border-color: #ccc;
      .vip-tag{
        color: #fff;
        background: #FF6767;
      }
      &.play{
        border-color: #FF6767;
      }
    }
  }
}

@keyframes showAllMenu{
  0%{
    top: 100vh;
  }
  100%{
    top: $playHeight;
  }
}
@keyframes closeAllMenu{
  0%{
    top: $playHeight;
  }
  100%{
    top: 100vh;
  }
}
</style>
